import React from "react";
import { Users } from "lucide-react";

const CollabCasesList = ({ cases, isLoading, error, onCaseSelect }) => {
  if (isLoading) {
    return (
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-6 text-sm text-slate-400 flex items-center gap-2">
        <Users className="w-4 h-4 text-yellow-400" />
        Loading shared cases...
      </div>
    );
  }

  if (cases.length === 0) {
    return (
      <div className="bg-slate-900 border border-slate-800 rounded-xl p-6">
        <div className="flex flex-col items-center gap-2 text-center">
          <div className="w-12 h-12 rounded-full bg-yellow-600/20 border border-yellow-500/40 flex items-center justify-center text-yellow-300">
            <Users className="w-5 h-5" />
          </div>
          <p className="text-lg font-semibold text-white">No shared cases yet</p>
          <p className="text-sm text-slate-400 max-w-md">
            Invite teammates from any case to collaborate.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl overflow-hidden overflow-x-auto">
      {error && (
        <div className="bg-yellow-500/10 border-b border-yellow-500/40 px-4 py-2 text-sm text-yellow-300">
          {error}
        </div>
      )}
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-slate-800 bg-slate-900/50 text-slate-400">
            <th className="p-4 font-medium">Case Number</th>
            <th className="p-4 font-medium">Borrower</th>
            <th className="p-4 font-medium">Role</th>
            <th className="p-4 font-medium">Shared With</th>
            <th className="p-4 font-medium">Status</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-800">
          {cases.map((row) => (
            <tr
              key={row.id}
              className="hover:bg-slate-800/50 transition-colors group cursor-pointer"
              onClick={() => onCaseSelect?.(row)}
            >
              <td className="p-4 text-slate-500">{row.caseNumber}</td>
              <td className="p-4 font-medium text-white">{row.name}</td>
              <td className="p-4">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-800 text-slate-200">
                  {row.role || "Collaborator"}
                </span>
              </td>
              <td className="p-4 text-slate-400">{row.sharedWithCount ?? 0}</td>
              <td className="p-4">
                <span
                  className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${row.status === "Approved"
                      ? "bg-green-500/10 text-green-400"
                      : row.status === "Action Required"
                        ? "bg-red-500/10 text-red-400"
                        : "bg-yellow-500/10 text-yellow-400"
                    }`}
                >
                  {row.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CollabCasesList;
